// extracted by mini-css-extract-plugin
export default {"chart":"bd_N4","fullscreen":"bd_dF","close":"bd_f2"};